import React, { useState, useEffect } from 'react';
import "./Top.scss";

const Top = () => {
  const [heightOver, setHeightOver] = useState(false);
  const scrollAction = () => {
    window.scrollY > 150 ? setHeightOver(true) : setHeightOver(false)
  };
  useEffect(() => {
    window.addEventListener("scroll", scrollAction, {
      capture: false,
      passive: true,
    });
    scrollAction();
    return () => {
      window.removeEventListener("scroll", scrollAction);
    };
  }, []);
  return (
    <div className="top_box">
    
   <div className="top_container">
     <div className="text text--h">H</div>
     <div className="text text--a">A</div>
     <div className="text text--y">Y</div>
     <div className="text text--a">A</div>
     <div className="text text--t">T</div>
     <div className="text text--o">O</div>
     <div className="text text--o">O</div>
     <div className="text text--k">K</div>
     <div className="text text--a">A</div>
     <div className="text text--m">M</div>
     <div className="text text--u">U</div>
     <div className="text text--r">R</div>
     <div className="text text--a">A</div>

     <div className="cube">

         <div className="panel panel--ou panel--o panel--u">
           <div className="square square--u square--o square1"></div>
           <div className="square square--u square--o square2"></div>
           <div className="square square--u square--o square3"></div>
           <div className="square square--u square--o square4"></div>
           <div className="square square--u square--o square5"></div>
           <div className="square square--u square--o square6"></div>

           <div className="square square--u square--o square7"></div>
           <div className="square square--u square--o square8"></div>
           <div className="square square--u square--o square9"></div>
           <div className="square square--u square--o square10"></div>
           <div className="square square--u square--o square11"></div>
           <div className="square square--u square--o square12"></div>

           <div className="square square--o square13"></div>
           <div className="square square--o square14"></div>
           <div className="square square--o square15"></div>
           <div className="square square--o square16"></div>
           <div className="square square--o square17"></div>
           <div className="square square--o square18"></div>

           <div className="square square--u square--o square19"></div>
           <div className="square square--u square--o square20"></div>
           <div className="square square--u square--o square21"></div>
           <div className="square square--u square--o square22"></div>
           <div className="square square--u square--o square23"></div>
           <div className="square square--u square--o square24"></div>
      </div>
      <div className="panel panel--ou2"></div>
      
       <div className="panel panel--h">
          <div className="square square--h square25"></div>
           <div className="square square--h square26"></div>
           <div className="square square--h square27"></div>
           <div className="square square--h square28"></div>
           <div className="square square--h square29"></div>
           <div className="square square--h square30"></div>

           <div className="square square--h square31"></div>
           <div className="square square--h square32"></div>
           <div className="square square--h square33"></div>
           <div className="square square--h square34"></div>
           <div className="square square--h square35"></div>
           <div className="square square--h square36"></div>

           <div className="square square--h square37"></div>
           <div className="square square--h square38"></div>
           <div className="square square--h square39"></div>
           <div className="square square--h square40"></div>
           <div className="square square--h square41"></div>
           <div className="square square--h square42"></div>
       </div>
       <div className="panel panel--h2"></div>

       <div className="panel panel--a">
          <div className="square square--a square43"></div>
          <div className="square square--a square44"></div>
          <div className="square square--a square45"></div>
          <div className="square square--a square46"></div>
          <div className="square square--a square47"></div>
          <div className="square square--a square48"></div>

           <div className="square square--a square49"></div>
           <div className="square square--a square50"></div>
           <div className="square square--a square51"></div>
           <div className="square square--a square52"></div>
           <div className="square square--a square53"></div>
           <div className="square square--a square54"></div>

           <div className="square square--a square55"></div>
           <div className="square square--a square56"></div>
           <div className="square square--a square57"></div>
           <div className="square square--a square58"></div>
           <div className="square square--a square59"></div>
           <div className="square square--a square60"></div>

           <div className="square square--a square61"></div>
           <div className="square square--a square62"></div>
           <div className="square square--a square63"></div>
           <div className="square square--a square64"></div>
           <div className="square square--a square65"></div>
           <div className="square square--a square66"></div>
       </div>
       <div className="panel panel--a2"></div>

       <div className="panel panel--tmy panel--t panel--m panel--y">
          <div className="square square--m square67"></div>
          <div className="square square--m square68"></div>
          <div className="square square--m square69"></div>
          <div className="square square--m square70"></div>
          <div className="square square--m square71"></div>
          <div className="square square--m square72"></div>

          <div className="square square--m square73"></div>
          <div className="square square--m square74"></div>
          <div className="square square--m square75"></div>
          <div className="square square--m square76"></div>
          <div className="square square--m square77"></div>
          <div className="square square--m square78"></div>

          <div className="square square--t square--m square--y square79"></div>
          <div className="square square--t square--m square--y square80"></div>
          <div className="square square--t square--m square--y square81"></div>
          <div className="square square--t square--m square--y square82"></div>
          <div className="square square--t square--m square--y square83"></div>
          <div className="square square--t square--m square--y square84"></div>

          <div className="square square--t square--m square--y square85"></div>
          <div className="square square--t square--m square--y square86"></div>
          <div className="square square--t square--m square--y square87"></div>
          <div className="square square--t square--m square--y square88"></div>
          <div className="square square--t square--m square--y square89"></div>
          <div className="square square--t square--m square--y square90"></div>

          <div className="square square--t square--m square91"></div>
          <div className="square square--t square--m square92"></div>
          <div className="square square--t square--m square93"></div>
          <div className="square square--t square--m square94"></div>
          <div className="square square--t square--m square95"></div>
          <div className="square square--t square--m square96"></div>

          <div className="square square--y square97"></div>
          <div className="square square--y square98"></div>
          <div className="square square--y square99"></div>
          <div className="square square--y square100"></div>
          <div className="square square--y square101"></div>
          <div className="square square--y square102"></div>

          <div className="square square--y square103"></div>
          <div className="square square--y square104"></div>
          <div className="square square--y square105"></div>
          <div className="square square--y square106"></div>
          <div className="square square--y square107"></div>
          <div className="square square--y square108"></div>

          <div className="square square--t square--m square109"></div> 
          <div className="square square--t square--m square110"></div> 
          <div className="square square--t square--m square111"></div> 
          <div className="square square--t square--m square112"></div> 
          <div className="square square--t square--m square113"></div> 
          <div className="square square--t square--m square114"></div> 

          <div className="square square--t square--m square--y square115"></div> 
          <div className="square square--t square--m square--y square116"></div> 
          <div className="square square--t square--m square--y square117"></div> 
          <div className="square square--t square--m square--y square118"></div> 
          <div className="square square--t square--m square--y square119"></div> 
          <div className="square square--t square--m square--y square120"></div> 

       </div>
       <div className="panel panel--tmy2"></div>

       <div className="panel panel--r">
        <div className="square square--r square121"></div>
        <div className="square square--r square122"></div>
        <div className="square square--r square123"></div>
        <div className="square square--r square124"></div>
        <div className="square square--r square125"></div>
        <div className="square square--r square126"></div>

        <div className="square square--r square127"></div>
       <div className="square square--r square128"></div>
       <div className="square square--r square129"></div>
       <div className="square square--r square130"></div>
       <div className="square square--r square131"></div>
       <div className="square square--r square132"></div>

       <div className="square square--r square133"></div>
       <div className="square square--r square134"></div>
       <div className="square square--r square135"></div>
       <div className="square square--r square136"></div>
       <div className="square square--r square137"></div>
       <div className="square square--r square138"></div>

       <div className="square square--r square139"></div>
       <div className="square square--r square140"></div>
       <div className="square square--r square141"></div>
       <div className="square square--r square142"></div>
       <div className="square square--r square143"></div>
       <div className="square square--r square144"></div>

       <div className="square square--r square145"></div>
       <div className="square square--r square146"></div>
       <div className="square square--r square147"></div>
       <div className="square square--r square148"></div>
       <div className="square square--r square149"></div>
       <div className="square square--r square150"></div>

       <div className="square square--r square151"></div>
       <div className="square square--r square152"></div>
       <div className="square square--r square153"></div>
       <div className="square square--r square154"></div>
       <div className="square square--r square155"></div>
       <div className="square square--r square156"></div>
       </div>
       <div className="panel panel--r2"></div>

       <div className="panel panel--k">
       <div className="square square--k square157"></div>
        <div className="square square--k square158"></div>
        <div className="square square--k square159"></div>
        <div className="square square--k square160"></div>
        <div className="square square--k square161"></div>
        <div className="square square--k square162"></div>

        <div className="square square--k square163"></div>
       <div className="square square--k square164"></div>
       <div className="square square--k square165"></div>
       <div className="square square--k square166"></div>
       <div className="square square--k square167"></div>
       <div className="square square--k square168"></div>

       <div className="square square--k square169"></div>
       <div className="square square--k square170"></div>
       <div className="square square--k square171"></div>
       <div className="square square--k square172"></div>
       <div className="square square--k square173"></div>
       <div className="square square--k square174"></div>

       <div className="square square--k square175"></div>
       <div className="square square--k square176"></div>
       <div className="square square--k square177"></div>
       <div className="square square--k square178"></div>
       <div className="square square--k square179"></div>
       <div className="square square--k square180"></div>

       <div className="square square--k square181"></div>
       <div className="square square--k square182"></div>
       <div className="square square--k square183"></div>
       <div className="square square--k square184"></div>
       <div className="square square--k square185"></div>
       <div className="square square--k square186"></div>

       <div className="square square--k square187"></div>
       <div className="square square--k square188"></div>
       <div className="square square--k square189"></div>
       <div className="square square--k square190"></div>
       <div className="square square--k square191"></div>
       <div className="square square--k square192"></div>
       </div>
       <div className="panel panel--k2"></div>

     </div>

   </div>
     <p className={heightOver ? "scroll" : "scroll-arrow"}><span></span>Scroll</p>
    </div>
  )
}

export default Top;